module.exports = __webpack_public_path__ + "img/mobile/Menus-betmenu/btn-sound_on@3x.png?1.0.17";